import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "button", "buttonText", "checkbox"]

  connect() {
    // Close dropdown when clicking outside
    this.boundCloseOnClickOutside = this.closeOnClickOutside.bind(this)
    document.addEventListener('click', this.boundCloseOnClickOutside)

    // Update button text on initial load
    this.updateButtonText()
  }

  disconnect() {
    document.removeEventListener('click', this.boundCloseOnClickOutside)
  }

  toggle(event) {
    event.stopPropagation()

    if (this.menuTarget.classList.contains('hidden')) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.menuTarget.classList.remove('hidden')
    this.buttonTarget.classList.add('ring-2', 'ring-indigo-500')
  }

  close() {
    this.menuTarget.classList.add('hidden')
    this.buttonTarget.classList.remove('ring-2', 'ring-indigo-500')
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  checkboxChanged() {
    this.updateButtonText()
  }

  updateButtonText() {
    const checkedCount = this.checkboxTargets.filter(cb => cb.checked).length
    const label = this.buttonTextTarget.dataset.label || 'Status'

    if (checkedCount === 0) {
      this.buttonTextTarget.textContent = label
    } else if (checkedCount === 1) {
      const checkedBox = this.checkboxTargets.find(cb => cb.checked)
      this.buttonTextTarget.textContent = checkedBox.dataset.label
    } else {
      this.buttonTextTarget.textContent = `${label} (${checkedCount})`
    }
  }
}
